const parserNumberBase1000 = (likes) => {
    switch (true) {
        case likes > 999 && likes < 10000:
            return (likes / 1000).toFixed(1) + 'K'
        case likes > 9999 && likes < 1000000:
            return (likes / 1000).toFixed(0) + 'M'
        case likes > 999999 && likes < 10000000:
            return (likes / 1000000).toFixed(0) + 'T'
        case likes > 9999999 && likes < 1000000000:
            return (likes / 1000000).toFixed(0) + 'B'
        default:
            return likes
    }
}

export { parserNumberBase1000 }